import { useReducer, useMemo } from 'react';

// Simple position state
type PositionState = 'IDLE' | 'NEEDS_REPOSITIONING';

// Events that trigger repositioning
type PositionEvent = 
  | { type: 'TRIGGER_REPOSITIONING' }
  | { type: 'REPOSITIONING_COMPLETE' };

// Initial state - idle
const initialState: PositionState = 'IDLE';

// Simple reducer for position state
function positionReducer(state: PositionState, event: PositionEvent): PositionState {
  switch (event.type) {
    case 'TRIGGER_REPOSITIONING':
      return 'NEEDS_REPOSITIONING';
    case 'REPOSITIONING_COMPLETE':
      return 'IDLE';
    default:
      return state;
  }
}

export function useBowtiePosition() {
  const [state, dispatch] = useReducer(positionReducer, initialState);

  const positionApi = useMemo(() => ({
    // Actions
    triggerRepositioning: () => dispatch({ type: 'TRIGGER_REPOSITIONING' }),
    repositioningComplete: () => dispatch({ type: 'REPOSITIONING_COMPLETE' }),
    
    // State accessors
    needsRepositioning: state === 'NEEDS_REPOSITIONING',
  }), [state]);

  return positionApi;
}